
export const FURNITURE_MATERIALS = ['Ahşap', 'Metal', 'Cam', 'Mermer', 'Sunta/Mdf', 'Plastik', 'Rattan', 'Hasır'];

export const FURNITURE_STYLES = ['Modern', 'Klasik', 'Endüstriyel', 'Retro', 'İskandinav', 'Country', 'Minimalist'];

export const TEXTILE_FABRICS = ['Pamuk', 'Polyester', 'Mikrofiber', 'İpek', 'Keten', 'Saten', 'Kadife', 'Bambu', 'Yün'];

export const APPLIANCE_ENERGY_CLASSES = ['A+++', 'A++', 'A+', 'A', 'B', 'C', 'D', 'E', 'F', 'G'];

export const BED_SIZES = [
    'Tek Kişilik (90x200)', 'Tek Kişilik (100x200)', 'Tek Kişilik (120x200)',
    'Çift Kişilik (140x200)', 'Çift Kişilik (150x200)', 'Queen Size (160x200)',
    'King Size (180x200)', 'Süper King (200x200)'
];

export const KITCHENWIRE_MATERIALS = ['Paslanmaz Çelik', 'Döküm', 'Granit', 'Teflon', 'Seramik', 'Cam', 'Bambu', 'Porselen'];
